import { render, staticRenderFns } from "./OrderCollectionOnDehalf.vue?vue&type=template&id=e74d8ad8&scoped=true"
import script from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
export * from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
import style0 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=0&id=e74d8ad8&prod&lang=scss&scoped=true"
import style1 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=1&id=e74d8ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74d8ad8",
  null
  
)

export default component.exports